import React from 'react';
import { Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { compose } from 'recompose';
import { UPLOAD_DOCUMENT_FORM } from '../../constants';
import { ReactSelect } from '../form/field/react_select';
import { styles } from './document-bar-styles';
import FileSelectedForm from './file-forms/file-selected-form';
import SelectFileForm from './file-forms/select-file-form';

const DocumentForm = props => {
  const {
    formTitle,
    classes,
    tags,
    fileSelected,
    showTargetTherapies,
    therapyOptions,
    selectedTherapiesForDocument,
    onTargetTherapiesChange,
  } = props;

  return (
    <>
      {formTitle && <Typography className={classes.title}>{formTitle}</Typography>}
      {tags && (
        // eslint-disable-next-line max-len
        <Typography className={classes.tag}>
          {tags
            .filter(t => t)
            .map(item => `#${item}`)
            .join(' ')}
        </Typography>
      )}
      {showTargetTherapies ? (
        <ReactSelect
          name="target_therapies"
          label={
            <div
              style={{
                fontSize: '15px',
                marginTop: '10px',
                marginBottom: '5px',
                fontWeight: 'bold',
              }}
            >
              Select target therapies for this document
            </div>
          }
          value={selectedTherapiesForDocument}
          handleOnChange={onTargetTherapiesChange}
          fields={therapyOptions}
          isMulti
          isClearable
          style={{
            menu: base => ({
              ...base,
              zIndex: 1330,
            }),
          }}
          id="document_target_therapy"
        />
      ) : null}
      {fileSelected ? (
        <FileSelectedForm form={UPLOAD_DOCUMENT_FORM} {...props} />
      ) : (
        <SelectFileForm {...props} />
      )}
    </>
  );
};

export default compose(withStyles(styles))(DocumentForm);
